import { render, staticRenderFns } from "./nawab-faisunnesa-bari.vue?vue&type=template&id=104e0dab&scoped=true&"
import script from "./nawab-faisunnesa-bari.vue?vue&type=script&lang=js&"
export * from "./nawab-faisunnesa-bari.vue?vue&type=script&lang=js&"
import style0 from "./nawab-faisunnesa-bari.vue?vue&type=style&index=0&id=104e0dab&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104e0dab",
  null
  
)

export default component.exports